import { createHashRouter } from "react-router-dom";
import { AppShell } from "@/layouts/AppShell";
import { CharacterCreatePage } from "@/pages/CharacterCreatePage";
import { CharacterSheetPage } from "@/pages/CharacterSheetPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { HomePage } from "@/pages/HomePage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { SettingsPage } from "@/pages/SettingsPage";

export const router = createHashRouter([
  {
    path: "/",
    element: <AppShell />,
    errorElement: <NotFoundPage />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "dashboard", element: <DashboardPage /> },
      { path: "characters/new", element: <CharacterCreatePage /> },
      { path: "characters/:characterId", element: <CharacterSheetPage /> },
      { path: "settings", element: <SettingsPage /> },
      { path: "*", element: <NotFoundPage /> }
    ]
  }
]);
